
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: false,
  section: 'Core Exchange',
  title: 'Authentication',
  description: 'Authentication options for the Core Exchange API'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Authentication' subtitle={metadata.description} mdxType="Header"></Header>
    <p>{`The Core Exchange API accepts an access token as a bearer token, for example `}<inlineCode parentName="p">{`curl -H 'Authorization: Bearer <ACCESS_TOKEN>'`}</inlineCode>{`. Plaid obtains that token through an `}<a parentName="p" {...{
        "href": "/core-exchange/docs/authentication/oauth-flow"
      }}>{`OAuth 2.0 authorization code flow`}</a>{`, with `}<a parentName="p" {...{
        "href": "/core-exchange/docs/authentication"
      }}>{`OpenID Connect (OIDC)`}</a>{` strongly recommended.`}</p>
    <p>{`As the Data Provider, you implement the authorization server and Plaid acts as the OAuth client. Plaid discovers your endpoints from your `}<inlineCode parentName="p">{`/.well-known/openid-configuration`}</inlineCode>{` document rather than using fixed URLs, so the values below are whatever you advertise there. See `}<a parentName="p" {...{
        "href": "/core-exchange/docs/authentication/oauth-server-setup#well-known-configuration"
      }}>{`OAuth server setup`}</a>{` for the full list of required properties.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Discovery property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`authorization_endpoint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hosts your login page, where the consumer authenticates.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`token_endpoint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Exchanges an authorization code for an access token, ID token, and refresh token.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`userinfo_endpoint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returns the user identifier. Required for OIDC; plain OAuth 2.0 implementations supply it via `}<inlineCode parentName="td">{`/customers/current`}</inlineCode>{` instead.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`jwks_uri`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Publishes the public keys Plaid uses to verify the `}<inlineCode parentName="td">{`id_token`}</inlineCode>{` signature.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "scopes"
    }}>{`Scopes`}</h2>
    <p>{`OIDC implementations must support `}<inlineCode parentName="p">{`openid`}</inlineCode>{` and `}<inlineCode parentName="p">{`offline_access`}</inlineCode>{` at a minimum; plain OAuth 2.0 implementations require `}<inlineCode parentName="p">{`offline_access`}</inlineCode>{`. Plaid may additionally request `}<a parentName="p" {...{
        "href": "/core-exchange/docs/authentication/oauth-server-setup#well-known-configuration"
      }}>{`FDX data scopes`}</a>{` such as `}<inlineCode parentName="p">{`fdx:accountbasic:read`}</inlineCode>{` or `}<inlineCode parentName="p">{`fdx:transactions:read`}</inlineCode>{` to describe the categories of data it's accessing. Your OAuth server does not need to enforce access control per FDX scope.`}</p>
    <h2 {...{
      "id": "related-guides"
    }}>{`Related guides`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/core-exchange/docs/authentication"
        }}>{`Authentication overview`}</a>{` — concepts, terminology, and the token model`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/core-exchange/docs/authentication/oauth-server-setup"
        }}>{`OAuth server setup`}</a>{` — well-known configuration, credentials, and JWKS`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/core-exchange/docs/authentication/oauth-flow"
        }}>{`Implementing the OAuth flow`}</a>{` — step-by-step parameters, responses, and error codes`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "scopes",
        level: 2,
        title: "Scopes",
      },
{
        id: "related-guides",
        level: 2,
        title: "Related guides",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
